import React, { useState, useEffect } from "react";
import {
  Box,
  List,
  ListItem,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Divider,
  AppBar,
  Toolbar,
  IconButton,
  Checkbox,
  Button,
  CardActionArea,
  Drawer,
  Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import QrCode2TwoToneIcon from "@mui/icons-material/QrCode2TwoTone";
import getCoupons from "../api/user/getCoupons";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { green, red } from "@mui/material/colors";
import { parseISO, format } from "date-fns";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import QRCodeDialog from "../component/QRCodeDialog";
import timeIcon from "../icons/page_time.png";
import qrcodeIcon from "../icons/page_qrcode.png";
import backIcon from "../icons/page_back.png";
const CouponPage = () => {
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupons, setSelectedCoupons] = useState([]);
  const [openQRCode, setOpenQRCode] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const userContext = useContext(AuthContext);
  const user = userContext.user || {};

  const parsedDate = (inputDateString) => {
    const date = parseISO(inputDateString, "dd-MM-yyyy HH:mm", new Date());
    const formattedDate = format(date, "yyyy/MM/dd HH:mm");
    return formattedDate;
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getCoupons();
        if (response.coupons !== null) {
          setCoupons(response.coupons);
        }
      } catch (error) {
        console.error("Failed to fetch coupons", error);
      }
    }
    if (userContext.user !== null) fetchData();
  }, []);

  const handleBackButtonClick = () => {
    navigate("/app");
  };

  const handleCardClick = (couponId) => {
    setSelectedCoupons((prev) =>
      prev.includes(couponId)
        ? prev.filter((id) => id !== couponId)
        : [...prev, couponId]
    );
  };

  const handleCheckboxChange = (event, couponId) => {
    event.stopPropagation(); // Prevents the click from reaching the CardActionArea
    setSelectedCoupons((prev) =>
      prev.includes(couponId)
        ? prev.filter((id) => id !== couponId)
        : [...prev, couponId]
    );
  };

  const isSelected = (couponId) => {
    return selectedCoupons.includes(couponId);
  };
  const generateCouponString = () => {
    const qrcode =
      "coupon:" + userContext.user.Id + "&&" + selectedCoupons.join("&&");
    return qrcode;
  };

  return (
    <Box
      width="100%"
      height="100vh"
      sx={{
        backgroundColor: theme.palette.background.default,
      }}
    >
      <AppBar           sx={{ bgcolor: theme.palette.appBar }}
          position="sticky"
          color="secondary">
        <Toolbar  sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <Box
              component="img"
              src={backIcon}
              alt="back"
              sx={{ width: "50px", marginLeft: "-16px" }}
              onClick={handleBackButtonClick}
            />
          <Typography
              align="center"
              sx={{
                fontWeight: "bold",
                fontSize: "h6.fontSize",
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
          >優惠券</Typography>
        </Toolbar>
      </AppBar>
      <Box m={1} />

      {userContext.user === null ? (
        <Typography
          marginTop={20}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
          align="center"
        >
          尚未登入
        </Typography>
      ) : (
        <>
          <List
            component={"nav"}
            aria-label="user coupons"
            sx={{
              paddingBottom: "20%",
              backgroundColor: theme.palette.background.default,
            }}
          >
            {coupons.map((coupon, index) => (
              <React.Fragment key={coupon.Id}>
                <ListItem>
                  <Checkbox
                    color="info"
                    sx={{ marginLeft: -2 }}
                    checked={isSelected(coupon.Id)}
                    onChange={(e) => handleCheckboxChange(e, coupon.Id)}
                  />
                  <CardActionArea onClick={() => handleCardClick(coupon.Id)}>
                    <Card
                      variant="outlined"
                      style={{
                        width: "100%",
                        backgroundColor: isSelected(coupon.Id)
                          ? theme.palette.action.selected
                          : "",
                      }}
                    >
                      <Stack direction={"row"}>
                        <Avatar
                          sx={{
                            margin: 2,
                            width: 60,
                            height: 60,
                            background: coupon.IsValid
                              ? theme.palette.selected
                              : "gray",
                          }}
                        >
                          ${coupon.Price}
                        </Avatar>
                        <Stack direction={"column"}>
                          <Typography>{coupon.Name}</Typography>{" "}
                          <Box>
                            <Box
                              component="img"
                              src={timeIcon}
                              sx={{ width: "14px", height: "14px" }}
                            />
                            {`${parsedDate(coupon.StartDate)}~ ${parsedDate(
                              coupon.EndDate
                            )}`}
                          </Box>
                          <Typography component="p">
                            {coupon.Description}
                          </Typography>
                          <Typography component="p">
                            {coupon.UsageCity!==""
                              ? "限制區域:" + coupon.UsageCity
                              : ""}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Card>
                  </CardActionArea>
                </ListItem>
                {index !== coupons.length - 1 && <Divider variant="middle" />}
              </React.Fragment>
            ))}
          </List>
          <Drawer anchor="bottom" variant="permanent">
            <Box sx={{ textAlign: "center", p: 2 }}>
              <Button
                variant="contained"
                onClick={() => setOpenQRCode(!openQRCode)}
                sx={{
                  fontSize: "16pt",
                  marginTop: 1,
                  marginRight: 1,
                  paddingX: 5,
                  background: theme.palette.selected,
                  color: "white",
                }}
              >
                <Box
                  component="img"
                  src={qrcodeIcon}
                  sx={{ width: "16px", height: "16px" }}
                />
                優惠券條碼
              </Button>
            </Box>
          </Drawer>
        </>
      )}
      <QRCodeDialog
        open={openQRCode}
        qrString={userContext.user !== null ? generateCouponString() : ""}
        onClose={() => setOpenQRCode(!openQRCode)}
        infoString={
          userContext.user !== null ? "請直接於售票機掃描" : "尚未登入"
        }
      ></QRCodeDialog>
    </Box>
  );
};

export default CouponPage;
